import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { environment } from '@workspace/ng-config';
import { LogLevel, PassedInitialConfig, provideAuth } from 'angular-auth-oidc-client';

const getBaseHref = (): string => {
  if (typeof document === 'undefined') return '/';
  return document.querySelector('base')?.getAttribute('href') || '/';
};
const getOrigin = (): string => {
  if (typeof window === 'undefined') return '';
  return window.location.origin;
};

const baseHref = getBaseHref();
const basePath = baseHref === '/' ? '' : baseHref.replace(/\/$/, '');
const origin = getOrigin();

export const authConfig: PassedInitialConfig = {
  config: {
    authority: `${environment.auth.keycloak.host}/realms/${environment.auth.keycloak.realm.name}`,
    redirectUrl: `${origin}${basePath}/auth/openid_connect/callback`,
    postLogoutRedirectUri: `${origin}${basePath}`,
    clientId: `${environment.auth.keycloak.realm.clientId}`,
    scope: 'openid email profile',
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    disableRefreshTokenOfflineAccessScopeWarning: true,
    //
    ignoreNonceAfterRefresh: true, // this is required if the id_token is not returned
    triggerRefreshWhenIdTokenExpired: false, // required when refreshing the browser if id_token is not updated after the first authentication
    // allowUnsafeReuseRefreshToken: true, // this is required if the refresh token is not rotated
    autoUserInfo: false, // if the user endpoint is not supported
    triggerAuthorizationResultEvent: true, // prevent default library redirect to postLoginRoute ('/') so returnUrl can be honored
    //
    logLevel: LogLevel.Warn,
  },
};

export const provideOpenId: EnvironmentProviders = makeEnvironmentProviders([provideAuth(authConfig)]);
